import serviceHandler from "@/helpers/handlers/service";
import usersService from "@/services/users";
import { GMBWithComparisionDataBase } from "./gmb-with-comparision-data-base";

export class GMBWithComparisionData extends GMBWithComparisionDataBase {
  async _getGMBDataFromApi(apiPayload) {
    return await serviceHandler(usersService.getGoogleInsightsOld(apiPayload));
  }

  async _getExportedFileFromApi(apiPayload, params) {
    return await serviceHandler(
      usersService.getGoogleInsightsOld(apiPayload, params)
    );
  }
}
